import { Row, Text } from 'components';
import { useSelector } from 'react-redux';

const Bio = ({ user }) => {
  const isMobile = useSelector((state) => state.appState.isMobile);

  if (!user?.bio) return null;

  return (
    <Row marg={isMobile && '0 16px'} start>
      <Text col={'#fff'} wordBreak="break-word">
        {user.bio}
      </Text>
    </Row>
  );
};

export default Bio;
